import gsap from 'gsap';
import scroll from '../js/scroll';

const header = () => {
  const nav = document.querySelector('.nav');

  const logo = document.querySelector('.header__logo');
  const logoOverlay = document.querySelector('.header__logo-overlay');
  const pull = document.querySelector('.header__pull');
  const pullOverlay = document.querySelector('.header__pull-overlay');
  const hello = document.querySelector('.header__hello');
  const helloOverlay = document.querySelector('.header__hello-overlay');
  const navHero = document.querySelector('.nav-hero');
  const navItem = document.querySelectorAll('.nav__item');

  if (!nav || !logo || !logoOverlay || !pull || !pullOverlay || !hello || !helloOverlay || !navHero) {
    return;
  }

  logoOverlay.classList.remove('visible');

  const openMenu = () => {
    const showOverlay = () => {
      logo.classList.add('hidden');
      logoOverlay.classList.add('visible');
      pull.classList.add('hidden');
      pullOverlay.classList.add('visible');
      hello.classList.add('hidden');
      helloOverlay.classList.add('visible');
    }

    setTimeout(showOverlay, 600);

    nav.classList.add('open');
    document.body.classList.add('isMenuOpened');

    const tweenNavOpen = gsap.timeline({paused: true});
    tweenNavOpen

    .fromTo(nav, {left: '-100%'}, {left: 0, duration: 0.7, ease: "expo.in"})
    .fromTo(navItem, {y: '50px', opacity: 0}, {y: 0, opacity: 1, duration: 0.3, ease: "expo.out", stagger: 0.05}, "+= 0.2")

    tweenNavOpen.restart();

  }

  const closeMenu = () => {
    const hideOverlay = () => {
      logo.classList.remove('hidden');
      logoOverlay.classList.remove('visible');
      pull.classList.remove('hidden');
      pullOverlay.classList.remove('visible');
      pullOverlay.classList.remove('closed');
      hello.classList.remove('hidden');
      helloOverlay.classList.remove('visible');
      scroll();
    }

    pullOverlay.classList.add('closed');

    setTimeout(hideOverlay, 600);
    nav.classList.remove('open');
    document.body.classList.remove('isMenuOpened');

    const tweenNavClose = gsap.timeline({paused: true});
    tweenNavClose

    .to(navItem, {y: '-200px', opacity: 0, duration: 0.3, ease: "expo.out"})
    .fromTo(nav, {left: '0'}, {left: '100%', duration: 0.8, ease: "expo.in"}, "-=1.4")

    tweenNavClose.restart();

  }

  pull.addEventListener('click', () => {
    openMenu();
  });

  pullOverlay.addEventListener('click', () => {
    closeMenu();
  });

  navHero.addEventListener('click', () => {
    closeMenu();
  });

  logoOverlay.addEventListener('click', () => {
    if (document.body.classList.contains('isMenuOpened')) {
      closeMenu();
    }
  });

  navItem.forEach(item => {
    item.addEventListener('click', () => {
      closeMenu();

    })
  })
}

export default header;
